import { CSSProperties, ReactNode } from 'react'

import {
  GreyGrey10,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  GreyWhite,
  Primary13Regular,
  RedRed10,
  RedRed50,
  Box,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { match } from 'ts-pattern'

export type SchedulePriceTableRow = {
  description: ReactNode
  billingType?: ReactNode
  billingFrequency?: ReactNode
  discount?: ReactNode
  amount?: ReactNode
  actions?: ReactNode
  hideBorder?: boolean
  alignCellContent?: 'top' | 'bottom' | 'center'
  style?: CSSProperties
  hasError?: boolean
  hasMinimum?: boolean
  onClick?: () => void
}

const getGridItemStyle = ({
  alignCellContent = 'top'
}: {
  alignCellContent?: 'top' | 'bottom' | 'center'
}) => ({
  display: 'flex',
  alignItems: match(alignCellContent)
    .with('top', () => 'flex-start')
    .with('bottom', () => 'flex-end')
    .with('center', () => 'center')
    .exhaustive(),
  ...Primary13Regular
})

export const Row = (props: SchedulePriceTableRow) => {
  const gridItemStyle = {
    ...getGridItemStyle({
      alignCellContent: props.alignCellContent
    })
  }

  return (
    <Grid
      className="group"
      gridTemplateColumns={`147fr 90fr 103fr 81fr 211fr 32px`}
      background={GreyWhite}
      minHeight="40px"
      position="relative"
      style={{
        ...props.style,
        ...(props.hasError
          ? { backgroundColor: RedRed10, color: RedRed50 }
          : { color: GreyGrey80 })
      }}
      padding="0 2px 0 8px"
      borderBottom={props.hideBorder ? undefined : `${GreyGrey30} 1px solid`}
      onClick={props.onClick}
      _hover={props.onClick ? { cursor: 'pointer', bg: GreyGrey10 } : {}}
    >
      <GridItem
        {...gridItemStyle}
        display="flex"
        alignItems="flex-start"
        gap="8px"
      >
        {props.description}
      </GridItem>
      <GridItem {...gridItemStyle} color={GreyGrey60}>
        {props.billingType}
      </GridItem>
      <GridItem {...gridItemStyle} color={GreyGrey60}>
        {props.billingFrequency}
      </GridItem>
      <GridItem {...gridItemStyle} color={GreyGrey60}>
        {props.discount}
      </GridItem>
      <GridItem {...gridItemStyle} justifyContent="flex-end" color={GreyGrey60}>
        {props.amount}
      </GridItem>
      <GridItem {...gridItemStyle}>{props.actions}</GridItem>
    </Grid>
  )
}
